// extracted by mini-css-extract-plugin
export default {"userTagWrapper":"index_userTagWrapper__Ow--h","iconContainer":"index_iconContainer__O-Iac","nameContainer":"index_nameContainer__8FAfu"};